import { Box, Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import fleetImage from './Asset/contact-desktop (1).jpg';
import { createWhatsAppUrl, FLEET_CAMPAIGN } from './siteConfig';
import { trackEvent } from './analytics';

const homeFleetUses = [
  {
    icon: BusinessOutlinedIcon,
    title: 'Kendaraan Operasional',
    text: 'Untuk aktivitas harian, tim lapangan, sales, dan kebutuhan manajemen.',
  },
  {
    icon: GroupsOutlinedIcon,
    title: 'Company Car',
    text: 'Pilihan kendaraan perusahaan dan program mobilitas karyawan.',
  },
  {
    icon: LocalShippingOutlinedIcon,
    title: 'Rental & Hospitality',
    text: 'Konsultasi armada untuk rental, hotel, travel, dan layanan bisnis.',
  },
];

function HomeFleetCampaign() {
  const whatsappUrl = createWhatsAppUrl();

  return (
    <Box
      component='section'
      aria-labelledby='home-fleet-title'
      sx={{
        position: 'relative',
        overflow: 'hidden',
        px: { xs: 2, md: 6 },
        py: { xs: 7, md: 9 },
        color: '#fff',
        backgroundColor: '#071b2b',
      }}
    >
      <Box
        component='img'
        src={fleetImage}
        alt='Jalur operasional perusahaan untuk transisi armada kendaraan listrik'
        width='2560'
        height='1080'
        sx={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          opacity: 0.22,
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background:
            'linear-gradient(90deg, rgba(7,27,43,0.98) 0%, rgba(7,27,43,0.88) 52%, rgba(7,27,43,0.55) 100%)',
        }}
      />
      <Box sx={{ position: 'relative', zIndex: 1, maxWidth: 1180, mx: 'auto' }}>
        <Typography
          sx={{
            display: 'inline-flex',
            px: 1.2,
            py: 0.6,
            borderRadius: '999px',
            color: '#071b2b',
            backgroundColor: '#71e1c2',
            fontSize: '0.78rem',
            fontWeight: 900,
            letterSpacing: 0.6,
            textTransform: 'uppercase',
          }}
        >
          B2B Corporate Fleet
        </Typography>
        <Typography
          id='home-fleet-title'
          component='h2'
          sx={{
            mt: 2,
            maxWidth: 820,
            fontSize: { xs: '2.25rem', sm: '3rem', md: '4.25rem' },
            fontWeight: 900,
            lineHeight: 0.98,
            letterSpacing: '-0.04em',
          }}
        >
          BYD Fleet untuk kebutuhan perusahaan
        </Typography>
        <Typography
          sx={{
            mt: 2,
            maxWidth: 760,
            color: 'rgba(255,255,255,0.78)',
            fontSize: { xs: '1rem', md: '1.08rem' },
            lineHeight: 1.75,
          }}
        >
          Konsultasi pengadaan beberapa unit BYD untuk kendaraan operasional,
          company car, rental fleet, atau transisi armada perusahaan ke EV di
          Jakarta, Tangerang, BSD, dan Jabodetabek.
        </Typography>

        <Box
          sx={{
            mt: 3.5,
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
            gap: 1.5,
            maxWidth: 1020,
          }}
        >
          {homeFleetUses.map((item) => {
            const Icon = item.icon;
            return (
              <Box
                key={item.title}
                sx={{
                  p: 2.2,
                  borderRadius: '12px',
                  border: '1px solid rgba(255,255,255,0.14)',
                  backgroundColor: 'rgba(255,255,255,0.07)',
                  backdropFilter: 'blur(8px)',
                }}
              >
                <Icon sx={{ color: '#71e1c2' }} />
                <Typography sx={{ mt: 1.2, fontWeight: 900 }}>{item.title}</Typography>
                <Typography sx={{ mt: 0.7, color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
                  {item.text}
                </Typography>
              </Box>
            );
          })}
        </Box>

        <Box sx={{ mt: 3.5, display: 'flex', flexWrap: 'wrap', gap: 1.3 }}>
          <Button
            component={RouterLink}
            to={FLEET_CAMPAIGN.path}
            onClick={() => trackEvent('fleet_home_click', { cta: 'landing_page' })}
            variant='contained'
            sx={buttonPrimary}
          >
            Minta Penawaran Fleet
          </Button>
          <Button
            href={whatsappUrl}
            target='_blank'
            rel='noopener noreferrer'
            onClick={() => trackEvent('fleet_whatsapp_click', { source: 'home_campaign' })}
            variant='outlined'
            sx={buttonGhost}
          >
            Konsultasi via WhatsApp
          </Button>
        </Box>
      </Box>
    </Box>
  );
}

const buttonPrimary = {
  px: 3.2,
  py: 1.15,
  borderRadius: '999px',
  color: '#071b2b',
  backgroundColor: '#71e1c2',
  textTransform: 'none',
  fontWeight: 900,
  '&:hover': { backgroundColor: '#55ceb0' },
};

const buttonGhost = {
  px: 3.2,
  py: 1.15,
  borderRadius: '999px',
  color: '#fff',
  borderColor: 'rgba(255,255,255,0.65)',
  textTransform: 'none',
  fontWeight: 900,
  '&:hover': {
    borderColor: '#fff',
    backgroundColor: 'rgba(255,255,255,0.08)',
  },
};

export default HomeFleetCampaign;
